import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectSectorField, {
  MxFormSelectSectorFieldProp
} from "@rf-l2/form/select/MxFormSelectSectorField";

interface MxFormL3SelectSectorFieldProps extends MxFormSelectSectorFieldProp {
  name: string;
  withreacthookform?: 1 | 0;
}
function MxFormL3SelectSectorField(props: MxFormL3SelectSectorFieldProps) {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectSectorField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
}

export default MxFormL3SelectSectorField;
